<template>
  <div class="content">
    <NavBar :navBlock="navBlock" :navtitle="navtitle"></NavBar>
    <div class="paddingContent">
      <div class="ListMenu">
        <div class="MenuBtnWrap">
          <div class="btn borderPurpleBtn" @click="changeListType">
            {{ listType ? "商品列表" : "草稿箱" }}
          </div>
          <div class="btn" @click="$router.push('/addGoods')">新增商品</div>
        </div>
      </div>
      <template v-if="listType === 0">
        <div class="tableWrap">
          <el-table :data="goodsList" height="660px" stripe style="width:100%;">
            <template slot="empty">
              <div class="no-data-container">
                <img
                  src="@/assets/images/common/no_data.png"
                  alt="暂无数据"
                  :style="{ width: '244px', height: '139px' }"
                />
              </div>
            </template>
            <el-table-column
              v-for="(item, index) in goodsTable"
              :key="index"
              :prop="item.prop"
              :label="item.label"
              :width="item.width"
            >
            </el-table-column>
            <el-table-column label="庫存操作" width="100">
              <template slot-scope="scope">
                <el-button
                  v-if="scope.row.status !== '關聯商品'"
                  @click="editStock(scope.row.id)"
                  type="text"
                  >編輯庫存
                </el-button>
              </template>
            </el-table-column>

            <el-table-column label="商品操作" width="180">
              <template slot-scope="scope">
                <el-button
                  v-if="scope.row.status !== '關聯商品'"
                  type="text"
                  @click="editGoods(scope.row.id)"
                  class="fontColorBlack"
                  >編輯商品
                </el-button>
                <!-- <el-button
                  type="text"
                  :disabled="
                    !(
                      scope.row.status == '即將售賣' &&
                      scope.row.shipFee == 1 &&
                      scope.row.distinguishArea == 1
                    )
                  "
                  @click="uploadModal(scope.row.id)"
                  class="fontColorBlack"
                  >上传运费模板
                </el-button> -->
                <el-button
                  type="text"
                  v-if="scope.row.status === '售賣中'"
                  @click="setSoldOut(scope.row)"
                  class="fontColorBlack"
                  >设为售罄
                </el-button>
                <el-button
                  type="text"
                  v-if="
                    scope.row.status !== '售賣中' &&
                      scope.row.status !== '已售完'
                  "
                  class="fontColorGrey"
                >
                  设为售罄
                </el-button>
                <el-button
                  type="text"
                  v-if="scope.row.status === '已售完'"
                  @click="setCancelSoldOut(scope.row)"
                  class="fontColorBlack"
                  >取消售罄
                </el-button>
              </template>
            </el-table-column>
            <el-table-column label="上架狀態" width="80">
              <template slot-scope="scope">
                <div>
                  {{ scope.row.listStatus == 1 ? "已上架" : "未上架" }}
                </div>
              </template>
            </el-table-column>
            <el-table-column label="上下架操作" width="180">
              <template slot-scope="scope">
                <el-button
                  class="downShelf fontColorBlack"
                  v-if="scope.row.listStatus == 1"
                  @click="itemDownshelf(scope.row.id)"
                  type="text"
                  >下架商品
                </el-button>
                <!--<el-button v-if="scope.row.status==='即將售賣' || scope.row.status==='灰度測試'" type="text"></el-button>-->
                <el-button
                  class="onShelves fontColorBlack"
                  v-if="scope.row.listStatus == 0"
                  @click="onShelvesProp(scope.row.id)"
                  type="text"
                  >上架商品
                </el-button>
              </template>
              <!--<template slot-scope="scope">-->
              <!--  <el-button class="downShelf" v-if="scope.row.status==='售賣中'" @click="itemDownshelf(scope.row.id)" type="text" >设为售罄</el-button>-->
              <!--  <el-button v-if="scope.row.status==='即將售賣' || scope.row.status==='灰度測試'" type="text" ></el-button>-->
              <!--  <el-button class="onShelves" v-if="scope.row.status==='已下架'" @click="onShelvesProp(scope.row.id)" type="text" >上架商品</el-button>-->
              <!--</template>-->
            </el-table-column>
          </el-table>
        </div>
        <div class="paging-block clearfix">
          <el-pagination
            class="paging fr"
            hide-on-single-page
            @current-change="handleCurrentChange"
            :current-page="currentPage"
            :page-size="10"
            :pager-count="5"
            layout="prev, pager, next, jumper"
            :total="total"
          >
          </el-pagination>
        </div>
      </template>
      <template v-if="listType === 1">
        <div class="tableWrap">
          <el-table :data="draftList" height="660px" stripe style="width:100%;">
            <el-table-column
              v-for="(item, index) in draftTable"
              :key="index"
              :prop="item.prop"
              :label="item.label"
              :width="item.width"
            >
            </el-table-column>
            <el-table-column label="操作">
              <template slot-scope="scope">
                <el-button @click="editDraft(scope.row.id)" type="text"
                  >編輯</el-button
                >
                <el-button @click="previewDraft(scope.row.id)" type="text"
                  >預覽</el-button
                >
                <el-button @click="deleteDraft(scope.row.id)" type="text"
                  >刪除</el-button
                >
              </template>
            </el-table-column>
          </el-table>
        </div>
        <div class="paging-block clearfix">
          <el-pagination
            class="paging fr"
            hide-on-single-page
            @current-change="handleDraftCurrentChange"
            :current-page="draftCurrentPage"
            :page-size="10"
            :pager-count="5"
            layout="prev, pager, next, jumper"
            :total="draftTotal"
          >
          </el-pagination>
        </div>
      </template>
    </div>
    <div v-if="propFlag" class="propWrap">
      <div class="prop-content mobile_show">
        <i class="iconfont icon-close fr hand" @click="closeProp"></i>
        <p class="prop-title normal_font">提示</p>
        <div class="detailsContent">
          <el-form>
            <el-form-item label="定時上架 ：">
              <el-switch active-color="#6C3DEA" v-model="goods.timing" @change="goods.shelfTime=''">
              </el-switch>
              <div class="timingTips" v-show="!goods.timing">
                <p>若關閉定時上架，您發佈的商品將會即時上架，請確認後發佈。</p>
              </div>
            </el-form-item>

            <el-form-item v-show="goods.timing" label="上架時間 ：">
              <el-date-picker
                v-model="goods.shelfTime"
                type="datetime"
                placeholder="选择时间"
              >
              </el-date-picker>
            </el-form-item>
          </el-form>
        </div>

        <div class="bottomBtn">
          <div class="btn borderBtn" @click="closeProp()">取消</div>
          <div class="btn hand new_btn" @click="onShelves()">上架</div>
        </div>
      </div>
    </div>
    <el-dialog
      title="提示信息"
      :visible.sync="uoloadModal"
      :close-on-press-escape="false"
      :close-on-click-modal="false"
      width="500px"
      center
    >
      <div class="dialog">
        <div>
          <el-upload
            ref="excelUpload"
            :action="this.$GLOBAL.yunfeiUrl"
            :with-credentials="true"
            class="upload-demo"
            :headers="{ Authorization: this.$cookie.get('auth') }"
            drag
            :accept="'.xlsx,.xls'"
            :multiple="false"
            :file-list="fileList"
            :on-change="fileChange"
            :on-success="successExcel"
            :on-error="errorExcel"
            :auto-upload="false"
            :data="{
              goodsId: goodsId
            }"
          >
            <img
              src="@/assets/images/common/blacklist_upload.png"
              alt="暂无数据"
              :style="{
                width: '41px',
                height: '41px',
                marginTop: '40px',
                marginBottom: '14px'
              }"
            />
            <div class="el-upload__text">
              將文件拖到此處，或<em>點擊上傳</em>
            </div>
            <div class="el-upload__tip" slot="tip">
              只能上傳單個xlsx/xls文件，並且只根據上傳內容進行更新
            </div>
          </el-upload>
          <div class="btngroup">
            <div
              class="btn borderBtn"
              style="marginRight:112px"
              @click="uoloadModal = false"
            >
              取消
            </div>
            <div class="btn" @click="submitupdate">確認更新</div>
          </div>
        </div>
      </div>
    </el-dialog>
    <el-dialog
      title="提示信息"
      :visible.sync="upTime"
      :close-on-press-escape="false"
      :close-on-click-modal="false"
      width="500px"
      center
    >
      <div class="flexCenter">
        <p style="margin-bottom: 20px;">選擇重新售卖時間</p>
        <el-date-picker
          v-model="shelfTime"
          type="datetime"
          placeholder="选择时间"
        >
        </el-date-picker>
        <div class="btn" style="margin-top: 20px;" @click="reonShelves()">
          下一步
        </div>
      </div>
    </el-dialog>
    <DiaMess v-if="dialogVisible"></DiaMess>
  </div>
</template>

<script>
import NavBar from "@/components/navBar";
import DiaMess from "@/components/dialog";

export default {
  data() {
    return {
      navBlock: "商城",
      navtitle: "商品列表",
      upTime: false,
      goodsList: [],
      draftList: [],
      listType: this.$store.getters.getListType || 0, // listType: 0 商品列表 1 草稿箱列表
      block: "",
      goodsTable: [
        {
          prop: "id",
          label: "商品id",
          width: "60"
        },
        {
          prop: "goodsTitle",
          label: "商品名稱",
          width: ""
        },
        {
          prop: "goodsType",
          label: "商品類型",
          width: "80"
        },
        {
          prop: "goodsUserType",
          label: "用戶類型",
          width: "80"
        },
        // {
        //   prop: "goodsTerm",
        //   label: "商品類別",
        //   width: "80"
        // },
        {
          prop: "totalNum",
          label: "總庫存",
          width: "80"
        },
        {
          prop: "dealNum",
          label: "成交",
          width: "80"
        },
        {
          prop: "startTime",
          label: "售賣時間",
          width: "170"
        },
        // {
        //   prop: "listStartTime",
        //   label: "上架時間",
        //   width: "170"
        // },
        {
          prop: "status",
          label: "商品狀態",
          width: "90"
        }
      ],
      draftTable: [
        {
          prop: "id",
          label: "草稿id",
          width: "100"
        },
        {
          prop: "goodsTitle",
          label: "商品名稱",
          width: ""
        },
        {
          prop: "goodsTerm",
          label: "商品類別",
          width: "150"
        },
        {
          prop: "updateTime",
          label: "最後更新時間",
          width: "200"
        }
      ],
      total: 0,
      draftTotal: 0,
      currentPage: 1,
      draftCurrentPage: 1,
      propFlag: false,
      goods: {
        timing: false,
        shelfTime: "",
        id: ""
      },
      updateTime: "0000-00-00 00：00：00",
      dialogVisible: false,
      uoloadModal: false,
      fileList: [],
      goodsId: "",
      shelfTime: "",
      goodsId: ""
    };
  },
  // created() {
  //   if (this.$store.getters.getListType === 0) {
  //     this.initList();
  //   } else {
  //     this.initDraftList();
  //   }
  // },
  activated() {
    if (this.$store.getters.getListType === 0) {
      this.initList();
    } else {
      this.initDraftList();
      this.listType = this.$store.getters.getListType;
    }
  },
  destroyed() {
    this.$message.closeAll();
  },
  methods: {
    uploadModal(id) {
      this.goodsId = id;
      this.uoloadModal = true;
    },
    fileChange(file, fileList) {
      this.fileList = fileList;
    },
    // excel上传成功
    successExcel(res, file, fileList) {
      let _this = this;
      if (res.code === "00000") {
        console.log(res);
        _this.dialogVisible = true;
        _this.$propMessage("运费模板上传成功", "success", function() {
          _this.dialogVisible = false;
        });
        _this.$refs.excelUpload.clearFiles();
        this.uoloadModal = false;
      } else {
        _this.dialogVisible = true;
        _this.$propMessage(res.message, "error", function() {
          _this.dialogVisible = false;
        });
        _this.$refs.excelUpload.clearFiles();
      }
    },
    // excel上传失败
    errorExcel(err, file, fileList) {
      let _this = this;
      _this.$refs.excelUpload.clearFiles();
      _this.dialogVisible = true;
      _this.$propMessage(err.message + ",請重新上傳", "error", function() {
        _this.dialogVisible = false;
      });
    },
    submitupdate() {
      this.$refs.excelUpload.submit();
    },
    // 初始化商品列表
    initList() {
      let param = {
        pageNo: this.currentPage,
        pageSize: 10,
        type: 5
      };
      this.$post(
        "/request/mall/findMallList",
        param,
        this.$GLOBAL.jsonConfig
      ).then(res => {
        console.log(res);
        if (res.code === "00000") {
          res.data.list.forEach(v => {
            v.startTime = this.$getTime(v.startTime);
            v.listStartTime = this.$getTime(v.listStartTime);
            let arr = ["全部", "VIP", "本年度vip", "指定VIP用户"];
            let arr2 = ["一般商品", "義賣商品", "年度會服商品"];
            let arr3 = ["所有用戶", "VIP用戶"];
            v.goodsTerm = arr[v.goodsTerm];
            v.goodsType = arr2[v.goodsType];
            v.goodsUserType = arr3[v.goodsUserType];
            switch (v.status) {
              case 0:
                v.status = "已售完";
                break;
              case 1:
                v.status = "售賣中";
                break;
              case 2:
                v.status = "即將售賣";
                break;
              case 3:
                v.status = "已下架";
                break;
              case 4:
                v.status = "灰度測試";
                break;
              case 5:
                v.status = "關聯商品";
                break;
            }
          });
          this.goodsList = res.data.list;
          this.total = res.data.allRow;
        } else {
          this.$propMessage(res.message, "error");
        }
      });
    },

    // 初始化草稿
    initDraftList() {
      this.$get(
        `/request/mall/findDraftMallList?pageNo=${
          this.draftCurrentPage
        }&pageSize=${10}`,
        {},
        this.$GLOBAL.jsonConfig
      ).then(res => {
        console.log(res);
        if (res.code === "00000") {
          res.data.list.forEach(v => {
            v.updateTime = this.$getTime(v.updateTime);
            let arr = ["全部", "VIP", "本年度vip", "指定VIP用户"];
            v.goodsTerm = arr[v.goodsTerm];
          });
          this.draftList = res.data.list;
          this.draftTotal = res.data.total;
        } else {
          this.$propMessage(res.message, "error");
        }
      });
    },

    handleCurrentChange(val) {
      this.currentPage = val;
      this.initList();
    },

    handleDraftCurrentChange(val) {
      this.draftCurrentPage = val;
      this.initDraftList();
    },

    // 編輯庫存
    editStock(id) {
      this.$router.push(`/editorialInventory?id=${id}&url=goodsList`);
    },
    // 編輯商品
    editGoods(id) {
      this.$router.push(`/editGoods?id=${id}`);
    },
    // 刪除商品
    delGoods(id) {
      let _this = this;
      _this
        .$confirm(
          "是否刪除該商品，刪除後將無法在列表中展示商品且用戶無法購買。確定刪除該商品嗎?",
          "提示信息",
          {
            confirmButtonText: "確認",
            cancelButtonText: "取消",
            center: true,
            closeOnClickModal: false
          }
        )
        .then(() => {
          //確認刪除商品
          _this
            .$get(
              `/request/mall/updateStatus/3/${id}/0/${_this.updateTime}`,
              {},
              _this.$GLOBAL.jsonConfig
            )
            .then(res => {
              _this.dialogVisible = true;
              if (res.code === "00000") {
                _this.$propMessage("刪除商品成功", "success", function() {
                  _this.dialogVisible = false;
                  _this.initList();
                });
              } else {
                _this.$propMessage(res.message, "error", function() {
                  _this.dialogVisible = false;
                });
              }
            });
        })
        .catch(() => {});
    },
    // 上架商品
    onShelvesProp(id) {
      this.propFlag = true;
      this.goods.id = id;
    },
    onShelves() {
      let _this = this;
      if (_this.goods.timing) {
        if (!_this.goods.shelfTime) {
          _this.dialogVisible = true;
          _this.$propMessage("請選擇上架時間", "error", function() {
            _this.dialogVisible = false;
          });
          return;
        }
        let time = new Date().getTime();
        if (time >= _this.goods.shelfTime) {
          _this.dialogVisible = true;
          _this.$propMessage("上架时间不能小于当前时间", "error", function() {
            _this.dialogVisible = false;
          });
          return;
        }
      }
      let status,
        isCron = "";
      // timing為true表示為定時上架
      status = _this.goods.timing ? 2 : 1;
      isCron = _this.goods.timing ? 1 : 0;
      if (_this.goods.timing) {
        // 定時上架
        const data = {
          goodsId: _this.goods.id,
          listStatus:_this.goods.timing&&_this.goods.shelfTime?0:1,
          listStartTime: _this.$formatDate(_this.goods.shelfTime)
        };
        _this
          .$post(
            `/request/mall/updateListStatus`,
            data,
            _this.$GLOBAL.jsonConfig
          )
          .then(res => {
            _this.dialogVisible = true;
            if (res.code === "00000") {
              _this.$propMessage("定時上架商品成功", "success", function() {
                _this.initList();
                _this.closeProp();
                _this.dialogVisible = false;
              });
            } else {
              let time = new Date().getTime();
              //比较当前时间和定时上架时间的大小
              if (time >= _this.goods.shelfTime) {
                _this.$propMessage(
                  "上架时间不能小于当前时间",
                  "error",
                  function() {
                    _this.dialogVisible = false;
                  }
                );
              } else {
                _this.$propMessage(res.message, "error", function() {
                  _this.dialogVisible = false;
                });
              }
            }
          });
      } else {
        // 即時上架
        const params = {
          goodsId: _this.goods.id,
          listStatus: 1,
        };
        _this
          .$post(
            `/request/mall/updateListStatus`,
            params,
            _this.$GLOBAL.jsonConfig
          )
          .then(res => {
            _this.dialogVisible = true;
            if (res.code === "00000") {
              _this.$propMessage("即時上架商品成功", "success", function() {
                _this.initList();
                _this.closeProp();
                _this.dialogVisible = false;
              });
            } else {
              _this.$propMessage(res.message, "error", function() {
                _this.dialogVisible = false;
              });
            }
          });
      }
    },
    //重新編輯上架
    reonShelves() {
      this.$message.closeAll();
      if (!this.shelfTime) {
        this.$message({
          type: "error",
          message: "請選擇售卖時間",
          center: true,
          duration: 1000
        });
        return;
      } else if (new Date(this.shelfTime).getTime() <= new Date().getTime()) {
        this.$message({
          type: "error",
          message: "售卖時間必須大於當前時間",
          center: true,
          duration: 1000
        });
        return;
      }
      this.upTime = false;
      this.$router.push(
        `/editGoods?id=${this.goodsId}&shelfTime=${this.$formatDate(
          this.shelfTime
        )}`
      );
    },
    // 下架商品
    itemDownshelf(goodsId) {
      let _this = this;
      _this
        .$confirm(
          "是否下架该商品，下架後商品将不在用户端商品列表中，但在管理后台仍可查看。確定下架该商品嗎?",
          "提示信息",
          {
            confirmButtonText: "確認",
            cancelButtonText: "取消",
            center: true,
            closeOnClickModal: false
          }
        )
        .then(() => {
          //確認下架商品
          let data = {
            listStatus: 0,
            goodsId
          };
          _this
            .$post(
              `/request/mall/updateListStatus`,
              data,
              _this.$GLOBAL.jsonConfig
            )
            .then(res => {
              _this.dialogVisible = true;
              if (res.code === "00000") {
                _this.$propMessage("下架商品成功", "success", function() {
                  _this.initList();
                  _this.dialogVisible = false;
                });
              } else {
                _this.$propMessage(res.message, "error", function() {
                  _this.dialogVisible = false;
                });
              }
            });
        })
        .catch(() => {});
    },
    // 编辑草稿
    editDraft(id) {
      this.$router.push(`/draftGoods?id=${id}`);
    },
    // 预览草稿
    previewDraft(id) {
      this.$router.push(`/goodsPreview?id=${id}`);
    },
    //删除草稿
    deleteDraft(id) {
      let _this = this;
      _this
        .$confirm("是否删除该商品草稿", "提示信息", {
          confirmButtonText: "確認",
          cancelButtonText: "取消",
          center: true,
          closeOnClickModal: false
        })
        .then(() => {
          _this
            .$get(
              `/request/mall/delDraftGoods?id=${id}`,
              {},
              this.$GLOBAL.jsonConfig
            )
            .then(res => {
              _this.dialogVisible = true;
              if (res.code === "00000") {
                _this.$propMessage("删除成功", "success", function() {
                  _this.initDraftList();
                  _this.dialogVisible = false;
                });
              } else {
                _this.$propMessage(res.message, "error", function() {
                  _this.dialogVisible = false;
                });
              }
            })
            .catch(() => {});
        });
    },
    changeListType() {
      this.listType = this.listType === 0 ? 1 : 0;
      this.$store.dispatch("setListType", this.listType);
    },

    closeProp() {
      this.propFlag = false;
      this.goods.timing = false;
    },

    setSoldOut(row) {
      let _this = this;
      _this
        .$confirm(
          "是否将商品状态改为已售完，修改后商品為已售完且用戶將無法進行購買。確定将该商品设为已售完嗎?",
          "提示信息",
          {
            confirmButtonText: "確認",
            cancelButtonText: "取消",
            center: true,
            closeOnClickModal: false
          }
        )
        .then(() => {
          //確認下架商品
          const params = {
            status: 0,
            goodsId: row.id
          };
          _this
            .$post(
              `/request/mall/updateStatus`,
              params,
              _this.$GLOBAL.jsonConfig
            )
            .then(res => {
              _this.dialogVisible = true;
              if (res.code === "00000") {
                _this.$propMessage("设置成功", "success", function() {
                  _this.initList();
                  _this.dialogVisible = false;
                });
              } else {
                _this.$propMessage(res.message, "error", function() {
                  _this.dialogVisible = false;
                });
              }
            });
        })
        .catch(action => {});
    },
    setCancelSoldOut(row) {
      let _this = this;
      _this.shelfTime = "";
      _this
        .$confirm("是否取消售罄並重新售卖商品?", "提示信息", {
          confirmButtonText: "重新編輯後售卖",
          cancelButtonText: "立即售卖",
          center: true,
          closeOnClickModal: false,
          distinguishCancelAndClose: true
        })
        .then(() => {
          //重新編輯後上架
          this.upTime = true;
          this.goodsId = row.id;
        })
        .catch(action => {
          if (action === "cancel") {
            this.cancelSoldOut(row);
          }
        });
    },
    cancelSoldOut(row) {
      let _this = this;
      _this
        .$confirm(
          "是否将商品状态改为售卖中，修改后商品為售卖中且用戶可以進行購買。確定将该商品设为售卖中嗎?",
          "提示信息",
          {
            confirmButtonText: "確認",
            cancelButtonText: "取消",
            center: true,
            closeOnClickModal: false
          }
        )
        .then(() => {
          //確認取消售罄
          let param = {
            goodsId: row.id,
            status: 1
          };
          _this
            .$post(
              `/request/mall/updateStatus`,
              param,
              _this.$GLOBAL.jsonConfig
            )
            .then(res => {
              _this.dialogVisible = true;
              if (res.code === "00000") {
                _this.$propMessage("设置成功", "success", function() {
                  _this.initList();
                  _this.dialogVisible = false;
                });
              } else {
                _this.$propMessage(res.message, "error", function() {
                  _this.dialogVisible = false;
                });
              }
            });
        })
        .catch(() => {});
    }
  },
  watch: {
    listType(newVal, oldVal) {
      if (newVal === 0) {
        this.initList();
      } else {
        this.initDraftList();
      }
    }
  },
  components: {
    NavBar,
    DiaMess
  }
};
</script>
<style lang="less" scoped>
.content {
  .paddingContent {
    .ListMenu {
      .MenuBtnWrap {
        display: flex;
        justify-content: flex-end;

        .btn:last-child {
          margin-left: 0.2rem;
        }
      }
    }

    .tableWrap {
      width: 100%;
      height: calc(100% - 152px);
      overflow: auto;
      word-break: break-all;

      .goodsOperate {
        display: inline-block;

        img {
          width: 0.16rem;
        }
      }

      .goodsOperate:last-child {
        margin-left: 0.2rem;
      }

      @media (max-width: 768px) {
        height: calc(100% - 92px);
      }

      @media (max-width: 420px) {
        height: calc(100% - 112px);
      }
      @media (min-width: 769px) {
        .downShelf {
          width: 0.8rem;
          padding-left: 0.2rem;
          background: url("../../../assets/images/market/downShelf.png")
            no-repeat center left;
        }

        .onShelves {
          width: 0.8rem;
          padding-left: 0.2rem;
          background: url("../../../assets/images/market/onShelves.png")
            no-repeat center left;
        }
      }
    }
  }

  .propWrap {
    .icon-close {
      margin: 10px;
    }

    .detailsContent {
      width: 100%;
      padding: 0.5rem;
      min-height: 0;
    }
  }
}

@media screen and (min-width: 769px) {
  .ListMenu {
    display: flex;
    justify-content: space-between;

    .searchForm {
      flex: 1;
      display: flex;
      justify-content: flex-start;
    }

    .MenuBtnWrap {
      flex: 1;
    }
  }

  .fontColorGrey {
    color: #938ea4;
    opacity: 0.3;
  }

  .fontColorBlack {
    color: #938ea4;
  }
}
.dialog {
  display: flex;
  justify-content: center;
  .el-upload__tip {
    color: #65676b;
  }
}
.btngroup {
  margin-top: 42px;
  display: flex;
  align-items: center;
  justify-content: center;
}
.btn {
  text-align: center;
}
.flexCenter {
  display: flex;
  flex-direction: column;
  align-items: center;
}

</style>



// WEBPACK FOOTER //
// src/pages/market/marketGoods/goodsList.vue